import { DaysToExtendTrial } from '@ViewModels';
import { StyleDeclarationValue, css } from 'aphrodite';
import * as React from 'react';
import { IUserSessionComponentProps } from '../../../models/AppState';
import { RadioButton } from '../../../web/components/RadioButton';
import { styleSheet } from './styles';

interface IProps extends IUserSessionComponentProps {
	className?: string;
	duration?: DaysToExtendTrial;
	setDuration?(duration: DaysToExtendTrial): void;
	styles?: StyleDeclarationValue[];
}

export const TrialExtensionSelect: React.FC<IProps> = props => {
	const { className, duration, setDuration, styles } = props;

	const onChange = (newDuration: DaysToExtendTrial) => () => {
		setDuration(newDuration);
	};

	return (
		<div
			className={`${css(styleSheet.container, ...(styles || []))} trial-extension-duration-select ${className || ''}`}
		>
			<RadioButton
				checked={duration === DaysToExtendTrial.Seven}
				id='trial-extension-seven'
				name='extension-duration-seven-days'
				onChange={onChange(DaysToExtendTrial.Seven)}
			>
				<div>Seven Days</div>
			</RadioButton>
			<RadioButton
				checked={duration === DaysToExtendTrial.Fourteen}
				id='trial-extension-fourteen'
				name='extension-duration-fourteen-days'
				onChange={onChange(DaysToExtendTrial.Fourteen)}
			>
				<div>Fourteen Days</div>
			</RadioButton>
			<RadioButton
				checked={duration === DaysToExtendTrial.Thirty}
				id='trial-extension-thirty'
				name='extension-duration-thirty-days'
				onChange={onChange(DaysToExtendTrial.Thirty)}
			>
				<div>Thirty Days</div>
			</RadioButton>
		</div>
	);
};
